<template>
  <!-- 远程控制 -->
  <div class="FilesManage">
    <div class="left-tree">
      <waterTree :dataList='dataList'></waterTree>
    </div>
    <div class="right-table">
      <div class="content">
        <div class="Files-top">
          <div class="ic-left">
            <div>
              <span>表编号：</span>
              <el-input v-model="deviceNo" size="mini" style="width: 150px; margin-right: 15px;"></el-input>
              <span>开始时间：</span>
              <el-date-picker v-model="beginTime" type="datetime" placeholder="选择开始时间" align="right"
                :picker-options="pickerOptions"> </el-date-picker>
              <span style="margin-left:15px">结束时间：</span>
              <el-date-picker v-model="endTime" type="datetime" placeholder="选择结束时间" align="right"
                :picker-options="pickerOptions"> </el-date-picker>

            </div>
            <div>
              <el-button type="primary" size="mini" plain @click="getList" style="margin-left:15px">查询</el-button>
              <!-- <el-button type="primary" size="mini" plain @click="getList" style="margin-left:15px">导入</el-button> -->
              <el-button type="primary" size="mini" plain @click="getList" style="margin-left:15px">导出</el-button>
            </div>
          </div>


        </div>
        <div class="Files-table">
          <el-table :data="tableData" stripe style="width: 100%" :height="heights">
            <template slot="empty">
              <span class="noData">
                <img src="../../assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <el-table-column label="序号" width="90" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="deviceNo" label="表编号" align="center"> </el-table-column>
            <el-table-column prop="realElectricQuantity" label="实时读数" align="center"> </el-table-column>
            <el-table-column prop="beginMeterReading" label="开始读数" align="center"> </el-table-column>
            <el-table-column prop="endMeterReading" label="结束读数" align="center"> </el-table-column>
            <el-table-column prop="electricReading" label="用水量" align="center"> </el-table-column>

            <el-table-column label="开始用水时间" align="center">
              <template #default="{row}">
                <span>{{row.beginTime | date_format}}</span>
              </template>
            </el-table-column>
            <el-table-column label="结束用水时间" align="center">
              <template #default="{row}">
                <span>{{row.endTime | date_format}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="differentMinutes" label="用水时长（分）" align="center"> </el-table-column>
          </el-table>
        </div>
        <div class="paging">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[15, 25, 35, 45, 55]" :page-size="15"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
  import waterTree from '@/components/module/tree/waterTree.vue'
  import {getMeterConsumption} from "../../api/zhongshanMeter";
  export default {
    components: {
      waterTree
    },
    data () {
      return {
        heights: document.getElementById('app').clientHeight-240,//屏幕高度 - 导航栏高度
        deviceNo: "",//表编号
        tableData: [],
        loading: false,
        total: 0,
        currentPage: 1,
        currentSize: 15,
        beginTime: new Date()-86400000,
        endTime: new Date(),
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },

          shortcuts: [{
            text: '今天',
            onClick (picker) {
              picker.$emit('pick',new Date());
            }
          },{
            text: '昨天',
            onClick (picker) {
              const date=new Date();
              date.setTime(date.getTime()-3600*1000*24);
              picker.$emit('pick',date);
            }
          },{
            text: '一周前',
            onClick (picker) {
              const date=new Date();
              date.setTime(date.getTime()-3600*1000*24*7);
              picker.$emit('pick',date);
            }
          }]
        },

      };
    },
    computed: {
      dataList () {
        var data=this.$store.unitStore.getters.getAreaTree
        return isempty(data)? []:[deviceList(data)]
      },
      nowArea () {
        var data=this.$store.cacheStore.state.setBuilding
        return data
      }

    },

    mounted () {
      this.getList()
    },
    watch: {
      dataList (v) {
        // console.log("侦听器",v);
      },
      nowArea () {
        this.getList()
      }
    },

    methods: {

      //获取数据
      getList () {
        var obj={
          'pageIndex': this.currentPage,
          'pageSize': this.currentSize,
          'areaId': this.nowArea.id,
          'deviceNo': this.deviceNo,
          'beginTime': typeof this.beginTime=='number'? this.beginTime:this.beginTime.getTime(),
          // 'beginTime':1671103311000,
          'endTime': typeof this.endTime=='number'? this.endTime:this.endTime.getTime(),
          // 'endTime':1671362511000,
        }
        let d={};
        for(let key in obj) {
          // 如果对象属性的值不为空，就保存该属性（如果属性的值为0，保存该属性。如果属性的值全部是空格，属于为空。）
          if((obj[key]===0||obj[key])&&obj[key].toString().replace(/(^\s*)|(\s*$)/g,'')!=='') {
            // 保存属性
            d[key]=obj[key];
          }
        }


        this.loading=true
        getMeterConsumption(d).then(res => {
          this.tableData=[]
          if(res.code==200) {


            this.total=res.data.numberResult.total
            this.tableData=res.data.dataResult.dataList
            this.loading=false
          } else {
            res.message? this.$message.error(res.message):this.$message.error('查看失败')
            this.loading=false
          }
        })
      },
      //分页功能
      newgetNowPageDataList () {
        this.getList()
      },
      handleSizeChange (val) {
        this.currentSize=val;
        this.newgetNowPageDataList();
      },
      handleCurrentChange (val) {
        this.currentPage=val;
        this.newgetNowPageDataList();
      }
    },
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
      //校验阀门状态
      date_state232 (val) {
        if(val==0) {
          return "关"
        } else if(val==1) {
          return "开"
        } else {
          return ""
        }
      },
      //校验通讯状态
      date_deviceState (val) {
        if(val==0) {
          return "掉线"
        } else if(val==1) {
          return "在线"
        } else {
          return ""
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .FilesManage {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;

    .left-tree {
      width: 3rem;
      height: 100%;
      flex-shrink: 0;
      margin-left: 10px;
      border-right: 1px solid #E6E6E6;
      overflow: hidden;
    }

    .el_Tree_Body {
      border: 0px;
    }

    .right-table {
      width: 100%;
      flex: 1;
      overflow: scroll;



      .Files-table {
        margin: 0px 20px;

        /deep/.el-table th {
          background-color: #F3F8FF;
          color: #999999;
          border-right: 1px solid #E6E6E6;
          padding: 10px 0px;
          font-weight: bold;
        }

        /deep/.el-table td {
          padding: 1px 0px;
          height: 44px;
        }

        /deep/.el-table th.is-leaf {
          border-bottom: 0px;
        }

        .status {
          width: 8px;
          height: 8px;
          display: inline-block;
          border-radius: 50%;
          position: relative;
          top: -1px;
        }

        .blue {
          background-color: #52A1FF;

        }

        .ash {
          background-color: #999999;

        }

        .buttoned_box {
          display: flex;
          justify-content: center;
          align-items: center;

          .line {
            display: inline-block;
            width: 1px;
            height: 20px;
            background-color: #E6E6E6;
            margin: 0px 20px;
          }

          .buttoned {
            cursor: pointer;
          }

          /deep/.el-button span {
            font-size: 15px;
            font-weight: 400;
          }
        }
      }

      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 10px;
        margin-right: 15px;
      }

    }

    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E6E6E6;

      span {
        color: #67A3ED;
        font-size: 14px;
        font-weight: bold;
      }

      .el-icon-close {
        font-size: 20px !important;
      }

    }

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #E6E6E6;

      button {
        padding: 8px 17px;
      }
    }

    .demo-temp {
      display: flex;
      flex-wrap: wrap;
    }

    /deep/.el-form-item {
      display: flex;
      margin-left: 20px;
    }

    /deep/.el-form-item__label {
      white-space: nowrap;
      width: 86px;
    }

    /deep/.el-dialog__body {
      padding: 20px 0px 0px 20px !important;
    }

    .dialog {
      /deep/.el-input__inner {
        width: 217px;
      }
    }

    /deep/.el-input__inner {
      height: 32px;
      line-height: 32px;
    }

    /deep/.el-input__icon {
      line-height: 32px;
    }

  }

  /deep/.el-tree-node__content {
    width: 3rem;
  }
</style>